import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  BuildingFloorEntranceList: [],
  PropertyUnitsCount: 0,
  CurrentOwnerDetailByContractId: {},
  ContractOwnerAndRenterDetails: null,
  PropertyUnitsDetail: null,
};

const buildingSlice = createSlice({
  name: "buildingSlice",
  initialState,
  reducers: {
    BuildingFloorEntranceAction: (state, action) => {
      state.BuildingFloorEntranceList = action.payload.BuildingFloorEntranceList;
    },
    PropertyUnitsCountAction: (state, action) => {
      state.PropertyUnitsCount = action.payload.PropertyUnitsCount;
    },
    CurrentOwnerDetailByContractIdAction: (state, action) => {
      state.CurrentOwnerDetailByContractId = action.payload.CurrentOwnerDetailByContractId;
    },
    ContractOwnerAndRenterDetailsAction: (state, action) => {
      state.ContractOwnerAndRenterDetails = action.payload.ContractOwnerAndRenterDetails;
    },
    PropertyUnitsDetailAction: (state, action) => {
      state.PropertyUnitsDetail = action.payload.PropertyUnitsDetail;
    },
    resetStatebuildingAction: () => initialState,
  },
});

export const {
  BuildingFloorEntranceAction,
  PropertyUnitsCountAction,
  CurrentOwnerDetailByContractIdAction,
  ContractOwnerAndRenterDetailsAction,
  PropertyUnitsDetailAction,
  resetStatebuildingAction 
} = buildingSlice.actions;

export default buildingSlice.reducer;
